<div>
  <p-autoComplete #autocomplete
                  [(ngModel)]="selectedMember"
                  [suggestions]="members"
                  (completeMethod)="completeMethod($event)"
                  (onSelect)="onSelect($event.value)"
                  (onHide)="onHide()"
                  [autofocus]="false"
                  [minLength]="1"
                  [autoZIndex]="true"
                  [unique]="true"
                  [forceSelection]="true"
                  scrollHeight="20vw"
                  appendTo="body"
                  placeholder="Enter ID, email or full name"
                  i18n-placeholder
                  dataKey="id"
                  optionLabel="email"
                  [showEmptyMessage]="true"
                  [emptyMessage]="emptyMessage"
                  class="w-full">
    <ng-template let-member
                 pTemplate="item">
      <div class="flex flex-row">
        <div class="flex flex-column">
          <span class="font-bold mb-2">{{ member.firstName }} {{ member.lastName }}</span>
          <small class="mb-2">ID {{ member.id }}</small>
          <span class="et-primary-email mb-2">{{ member.email }}</span>
        </div>
      </div>
    </ng-template>
  </p-autoComplete>
</div>